import * as React from "react";
import { useMemo, useState, useEffect, useCallback } from "react";
import { v4 as uuid } from "uuid";
import AutoRefreshContext from "views/components/contexts/AutoRefreshContext";
const AutoRefreshProvider = ({
  children = null,
  onRefresh,
  defaultRefreshConfig = null
}) => {
  const [refreshConfig, setRefreshConfig] = useState(defaultRefreshConfig);
  const [animationId, setAnimationId] = useState((defaultRefreshConfig == null ? void 0 : defaultRefreshConfig.enabled) ? uuid() : null);
  const startAutoRefresh = useCallback((interval) => {
    if (interval > 0) {
      setRefreshConfig({ enabled: true, interval });
      setAnimationId(uuid());
    }
  }, []);
  const stopAutoRefresh = useCallback(() => {
    setRefreshConfig((cur) => ({ ...cur, enabled: false }));
    setAnimationId(null);
  }, []);
  useEffect(() => {
    let refreshInterval = null;
    if ((refreshConfig == null ? void 0 : refreshConfig.enabled) && (refreshConfig == null ? void 0 : refreshConfig.interval) > 0) {
      refreshInterval = setInterval(() => {
        setAnimationId(uuid());
        onRefresh();
      }, refreshConfig == null ? void 0 : refreshConfig.interval);
    }
    return () => {
      clearInterval(refreshInterval);
    };
  }, [refreshConfig == null ? void 0 : refreshConfig.enabled, refreshConfig == null ? void 0 : refreshConfig.interval, onRefresh, animationId]);
  const restartAutoRefresh = useCallback(() => {
    if (refreshConfig == null ? void 0 : refreshConfig.enabled) {
      setAnimationId(uuid());
    }
  }, [refreshConfig == null ? void 0 : refreshConfig.enabled]);
  const contextValue = useMemo(
    () => ({
      refreshConfig,
      startAutoRefresh,
      stopAutoRefresh,
      animationId,
      restartAutoRefresh
    }),
    [animationId, refreshConfig, restartAutoRefresh, startAutoRefresh, stopAutoRefresh]
  );
  return /* @__PURE__ */ React.createElement(AutoRefreshContext.Provider, { value: contextValue }, children);
};
export default AutoRefreshProvider;
